import { faSave, faTrash, faWarehouse } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { cloneDeep } from 'lodash'
import { useEffect, useState } from 'react'
import { Form, InputGroup, Modal } from 'react-bootstrap'
import { useForm } from '../../../../../../../hooks/useForm'
import { useValidator } from '../../../../../../../hooks/useValidator'
import { useLang } from '../../../../../../../language'
import { PersonaColegiadoBTServices } from '../../controllers/personacolegiadobt.service'
import { InputSelect } from '../../../../../../../components/Inputs/InputSelect'
import { ButtonSpinner } from '../../../../../../../components/ButtonSpinner/ButtonSpinner'
import { ModalStatusServer } from '../../../../../../../components/Modals/ModalStatusServer'
import { isStatusSucess } from '../../../../../../../helpers/helpers'

export const ModalNivelIdioma = ({ data, handleClose, fetchMultipleParamBolsaData, fetchPersonaBTGET }: any) => {

    // -------- variables 

    const Lang = useLang()

    const [valuesValidationEntidades, handleValidationEntidades, handleResetValidationEntidades] = useValidator({
        ididioma: { isOk: true, msgError: [Lang('ALERT_OBLIGATORIO_GENERICO')] },
        idnivelidioma: { isOk: true, msgError: [Lang('ALERT_OBLIGATORIO_GENERICO')] },
    })

    // -------- Formulario principal

    const [
        formPersonaEntidad, handleInputPersonaEntidad, handleFormPersonaEntidad, resetFormPersonaEntidad
    ] = useForm({
        ididioma: '',
        idnivelidioma: '',
    })

    // -------------------- PATCH Persona Entidad

    const [fetchPersonaEntidadPATCH, fetchPersonaEntidadPATCHData] = PersonaColegiadoBTServices.PATCH_IDIOMAS()

    const handleSubmitCrear = () => {

        

        if (handleValidationEntidades(formPersonaEntidad)) {

            const dataTemp = [...data.data, { ...formPersonaEntidad }]

            fetchPersonaEntidadPATCH({
                body: {
                    idiomas: dataTemp
                }
            })
        }
    }

    const handleSubmitEditar = () => {

        const dataTemp = [...data.data]

        dataTemp.splice(data?.index, 1)

        fetchPersonaEntidadPATCH({
            body: {
                idiomas: dataTemp
            }
        })
    }

    useEffect(() => {
        if (isStatusSucess(fetchPersonaEntidadPATCHData.status)) {
            fetchPersonaBTGET()
            handleClose()
        }
    }, [fetchPersonaEntidadPATCHData])


    // Acciones al Mostrar / Ocultar la Modal

    useEffect(() => {
        

        if (data.value) {

            if (data.item?.ididioma) {

                // fetchPersonaEntidadGET()
                handleFormPersonaEntidad({
                    ...data.item,
                })
            }

        } else {
            resetFormPersonaEntidad()
            handleResetValidationEntidades()
        }
    }, [data.value])

    return (
        <>
            <Modal show={data.value} onHide={handleClose} size='lg' id='ModalRegistro'>
                <Modal.Header className='border-bottom-0 py-4'>
                    <Modal.Title className='h5'>
                        {data.action === 'EDIT' ? Lang('AGREGAR_NIVEL_IDIOMA') : Lang('EDITAR_NIVEL_IDIOMA')}
                    </Modal.Title>
                    <button type="button" className="btn-close mx-0" aria-label="Close" onClick={handleClose}></button>
                </Modal.Header>

                <Modal.Body className='px-4 py-0'>
                    <Form className='row'>

                        <Form.Group className="mb-3 col-12 col-sm-6 col-md-7 col-lg-5 col-xl-5 col-xxl-5">
                            <InputSelect
                                label={`${Lang('IDIOMAS')}:`}
                                name='ididioma'
                                value={formPersonaEntidad.ididioma}
                                values={fetchMultipleParamBolsaData?.data?.['idiomas'] || []}
                                onChange={handleInputPersonaEntidad}
                                // fetchData={data.action === 'CREATE' ? fetchPersonaEntidadPOSTData : fetchPersonaEntidadPATCHData}
                                validation={valuesValidationEntidades}
                                readonly={data.action === 'EDIT'}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3 col-12 col-sm-6 col-md-7 col-lg-5 col-xl-5 col-xxl-5">
                            <InputSelect
                                label={`${Lang('NIVEL_IDIOMA')}:`}
                                name='idnivelidioma'
                                value={formPersonaEntidad.idnivelidioma}
                                values={fetchMultipleParamBolsaData?.data?.['nivelidioma'] || []}
                                onChange={handleInputPersonaEntidad}
                                // fetchData={data.action === 'CREATE' ? fetchPersonaEntidadPOSTData : fetchPersonaEntidadPATCHData}
                                validation={valuesValidationEntidades}
                                readonly={data.action === 'EDIT'}
                            />
                        </Form.Group>

                    </Form>
                </Modal.Body>
                <Modal.Footer className='border-0 d-flex justify-content-between'>
                    {
                        data.action === 'CREATE' ?
                            <>
                                <div></div>
                                <ButtonSpinner
                                    variant="secondary" type="submit" className="me-2"
                                    handleSubmit={handleSubmitCrear} fetchDataLoading={[fetchPersonaEntidadPATCHData.loading]}
                                    value={Lang('GUARDAR')} icon={<FontAwesomeIcon icon={faSave} />}
                                />
                            </>
                            :
                            <>
                                <ButtonSpinner
                                    variant="danger" type="submit" className="me-2"
                                    handleSubmit={handleSubmitEditar} fetchDataLoading={[fetchPersonaEntidadPATCHData.loading]}
                                    value={Lang('ELIMINAR')} icon={<FontAwesomeIcon icon={faTrash} />}
                                />
                                <div></div>
                            </>
                    }

                </Modal.Footer>
            </Modal>

            {/* <FilterEntidad
                showModal_FiltroEntidades={showModal_FiltroEntidades}
                handleClose_FiltroEntidades={handleClose_FiltroEntidades}
                setFilterEntidad={setFilterEntidad}
            />

            <ModalStatusServer fetchData={fetchPersonaEntidadPOSTData}
            />

            <ModalStatusServer fetchData={fetchPersonaEntidadDELETEData} /> */}

            <ModalStatusServer fetchData={fetchPersonaEntidadPATCHData} />

        </>
    )
}
